import {useEffect, useReducer} from "react";

import {IRPStore} from "../../app/rp_reducer";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {applicationModalStepReducer, initialStepState, ModalStepActionTypes} from "../reducers/application_modal_step_reducer";
import {ISentLeadActions, setDidSubmitOnMountAction} from "../reducers/lead_form_reducer";
import {resetMainLeadData, setLeadModalMainLeadType} from "../state/main_lead_slice";
import {ApplicationModalStep} from "../types/ApplicationModalStep";
import {ILeadModalLeadType} from "../types/lead/ILeadModalLeadType";
import {ApplicationSource, ApplicationSourceSection} from "../utils/form/application_form_source";
import {getApplicationStoreHash} from "../utils/get_application_store_hash";
import {useInitialLeadFormValues} from "./use_initial_lead_form_values";
import {useLeadData} from "./use_lead_data";
import {useLeadRequiredParams} from "./use_lead_required_params";

export const useApplicationModalArray = () => {
    const dispatch = useAppDispatch();

    const {vendorId, offerId, propertyId} = useLeadRequiredParams();
    const parametrizedStoreHash = getApplicationStoreHash({
        vendorId,
        offerId,
        propertyId
    });

    const {isModalOpen, source, sourceSection, customFormText, initialStep, forceClose} = useAppSelector((state) => state.mainLead);
    const isAutoresponderEnabled = useAppSelector(
        (state: IRPStore) => state.application[parametrizedStoreHash]?.offer?.detail?.configuration.is_autoresponder_enabled
    );

    const leadData = useLeadData({
        storeHash: parametrizedStoreHash,
        vendorId,
        offerId: offerId || undefined,
        propertyId: propertyId || undefined,
        skipFetch: !isModalOpen
    });

    const initialLeadFormValues = useInitialLeadFormValues({
        leadData,
        realEstateIds: {offerId: offerId || undefined, propertyId: propertyId || undefined, vendorId},
        resetValues: !isModalOpen,
        customFormText: customFormText || undefined
    });

    const isLeadDataLoading = !initialLeadFormValues || !leadData;
    const isAbroad = leadData?.offer?.detail?.region.country && leadData?.offer?.detail?.region.country !== 1; // Country.POLAND = 1

    const [modalStepState, dispatchModalStepState] = useReducer(applicationModalStepReducer, {
        ...initialStepState,
        ...(initialStep && {step: initialStep}),
        isAutoresponderEnabled: !!isAutoresponderEnabled,
        forceClose: !!forceClose
    });

    /**
     * effect to manage the initial step when opening the modal if no initialStep is provided
     */
    useEffect(() => {
        if (!isModalOpen || isLeadDataLoading) {
            return;
        }

        const shouldUseFullOfferForm = propertyId && !isAbroad;
        const isSimpleFormStep =
            initialStep === ApplicationModalStep.APPLICATION_FORM_FULL_OFFER || initialStep === ApplicationModalStep.APPLICATION_FORM_WITH_NEGOTIATION;
        const isSidebarForm = initialStep === ApplicationModalStep.MULTILEAD && sourceSection === ApplicationSourceSection.SIDEBAR;

        let mainLeadType: ILeadModalLeadType;
        if (shouldUseFullOfferForm || isSimpleFormStep) {
            mainLeadType = "simple";
        } else if (isSidebarForm) {
            mainLeadType = "sidebar_form";
        } else {
            mainLeadType = "standard";
        }

        dispatch(setLeadModalMainLeadType(mainLeadType));

        if (initialStep) {
            return;
        }

        if (shouldUseFullOfferForm) {
            dispatchModalStepState({
                type: ModalStepActionTypes.OPEN,
                payload: {step: ApplicationModalStep.APPLICATION_FORM_FULL_OFFER}
            });
        } else {
            dispatchModalStepState({
                type: ModalStepActionTypes.OPEN,
                payload: {
                    step: ApplicationModalStep.APPLICATION_FORM_STANDARD
                }
            });
        }
    }, [isModalOpen, isLeadDataLoading]);

    /**
     * effect to close the modal when the step is set to close
     */
    useEffect(() => {
        if (modalStepState.step === ApplicationModalStep.CLOSE) {
            dispatch(resetMainLeadData());
            dispatch<ISentLeadActions>(setDidSubmitOnMountAction(false));
        }
    }, [modalStepState.step]);

    /**
     * effect to update the isAutoresponderEnabled value in the modal step state
     */
    useEffect(() => {
        // `isAutoresponderEnabled` is value from API, so we need to update this value in reducer state
        if (isModalOpen && isAutoresponderEnabled) {
            dispatchModalStepState({type: ModalStepActionTypes.SET_IS_AUTORESPONDER_ENABLED, payload: {isAutoresponderEnabled}});
        }
    }, [isAutoresponderEnabled, isModalOpen]);

    /**
     * effect to update the lead data in the modal step state
     */
    useEffect(() => {
        if (leadData) {
            dispatchModalStepState({type: ModalStepActionTypes.UPDATE_LEAD_DATA, payload: leadData});
        }
    }, [leadData, isModalOpen]);

    /**
     * effect to verify that `source` and `sourceSection` are defined
     */
    useEffect(() => {
        if (!source || !sourceSection) {
            notifyBugsnag("source or sourceSection is undefined", "useApplicationModalArray - source verification");
        }
    }, [source, sourceSection]);

    return {
        isOpened: isModalOpen,
        source: source as ApplicationSource,
        sourceSection: sourceSection as ApplicationSourceSection,
        modalStepState,
        dispatchModalStepState,
        parametrizedStoreHash,
        leadData,
        initialLeadFormValues,
        customFormText
    };
};
import {useEffect, useReducer} from "react";

import {IRPStore} from "../../app/rp_reducer";
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {applicationModalStepReducer, initialStepState, ModalStepActionTypes} from "../reducers/application_modal_step_reducer";
import {ISentLeadActions, setDidSubmitOnMountAction} from "../reducers/lead_form_reducer";
import {resetMainLeadData, setLeadModalMainLeadType} from "../state/main_lead_slice";
import {ApplicationModalStep} from "../types/ApplicationModalStep";
import {ILeadModalLeadType} from "../types/lead/ILeadModalLeadType";
import {ApplicationSource, ApplicationSourceSection} from "../utils/form/application_form_source";
import {getApplicationStoreHash} from "../utils/get_application_store_hash";
import {useInitialLeadFormValues} from "./use_initial_lead_form_values";
import {useLeadData} from "./use_lead_data";
import {useLeadRequiredParams} from "./use_lead_required_params";

export const useApplicationModalArray = () => {
    const dispatch = useAppDispatch();

    const {vendorId, offerId, propertyId} = useLeadRequiredParams();
    const parametrizedStoreHash = getApplicationStoreHash({
        vendorId,
        offerId,
        propertyId
    });

    const {isModalOpen, source, sourceSection, customFormText, initialStep, forceClose} = useAppSelector((state) => state.mainLead);
    const isAutoresponderEnabled = useAppSelector(
        (state: IRPStore) => state.application[parametrizedStoreHash]?.offer?.detail?.configuration.is_autoresponder_enabled
    );

    const leadData = useLeadData({
        storeHash: parametrizedStoreHash,
        vendorId,
        offerId: offerId || undefined,
        propertyId: propertyId || undefined,
        skipFetch: !isModalOpen
    });

    const initialLeadFormValues = useInitialLeadFormValues({
        leadData,
        realEstateIds: {offerId: offerId || undefined, propertyId: propertyId || undefined, vendorId},
        resetValues: !isModalOpen,
        customFormText: customFormText || undefined
    });

    const isLeadDataLoading = !initialLeadFormValues || !leadData;
    const isAbroad = leadData?.offer?.detail?.region.country && leadData?.offer?.detail?.region.country !== 1; // Country.POLAND = 1

    const [modalStepState, dispatchModalStepState] = useReducer(applicationModalStepReducer, {
        ...initialStepState,
        ...(initialStep && {step: initialStep}),
        isAutoresponderEnabled: !!isAutoresponderEnabled,
        forceClose: !!forceClose
    });

    /**
     * effect to manage the initial step when opening the modal if no initialStep is provided
     */
    useEffect(() => {
        if (!isModalOpen || isLeadDataLoading) {
            return;
        }

        const shouldUseFullOfferForm = propertyId && !isAbroad;
        const isSimpleFormStep =
            initialStep === ApplicationModalStep.APPLICATION_FORM_FULL_OFFER || initialStep === ApplicationModalStep.APPLICATION_FORM_WITH_NEGOTIATION;
        const isSidebarForm = initialStep === ApplicationModalStep.MULTILEAD && sourceSection === ApplicationSourceSection.SIDEBAR;

        let mainLeadType: ILeadModalLeadType;
        if (shouldUseFullOfferForm || isSimpleFormStep) {
            mainLeadType = "simple";
        } else if (isSidebarForm) {
            mainLeadType = "sidebar_form";
        } else {
            mainLeadType = "standard";
        }

        dispatch(setLeadModalMainLeadType(mainLeadType));

        if (initialStep) {
            return;
        }

        if (shouldUseFullOfferForm) {
            dispatchModalStepState({
                type: ModalStepActionTypes.OPEN,
                payload: {step: ApplicationModalStep.APPLICATION_FORM_FULL_OFFER}
            });
        } else {
            dispatchModalStepState({
                type: ModalStepActionTypes.OPEN,
                payload: {
                    step: ApplicationModalStep.APPLICATION_FORM_STANDARD
                }
            });
        }
    }, [isModalOpen, isLeadDataLoading]);

    /**
     * effect to close the modal when the step is set to close
     */
    useEffect(() => {
        if (modalStepState.step === ApplicationModalStep.CLOSE) {
            dispatch(resetMainLeadData());
            dispatch<ISentLeadActions>(setDidSubmitOnMountAction(false));
        }
    }, [modalStepState.step]);

    /**
     * effect to update the isAutoresponderEnabled value in the modal step state
     */
    useEffect(() => {
        // `isAutoresponderEnabled` is value from API, so we need to update this value in reducer state
        if (isModalOpen && isAutoresponderEnabled) {
            dispatchModalStepState({type: ModalStepActionTypes.SET_IS_AUTORESPONDER_ENABLED, payload: {isAutoresponderEnabled}});
        }
    }, [isAutoresponderEnabled, isModalOpen]);

    /**
     * effect to update the lead data in the modal step state
     */
    useEffect(() => {
        if (leadData) {
            dispatchModalStepState({type: ModalStepActionTypes.UPDATE_LEAD_DATA, payload: leadData});
        }
    }, [leadData, isModalOpen]);

    /**
     * effect to verify that `source` and `sourceSection` are defined
     */
    useEffect(() => {
        if (!source || !sourceSection) {
            notifyBugsnag("source or sourceSection is undefined", "useApplicationModalArray - source verification");
        }
    }, [source, sourceSection]);

    return {
        isOpened: isModalOpen,
        source: source as ApplicationSource,
        sourceSection: sourceSection as ApplicationSourceSection,
        modalStepState,
        dispatchModalStepState,
        parametrizedStoreHash,
        leadData,
        initialLeadFormValues,
        customFormText
    };
};
